import { IToolActionParams, IToolActionResponse } from './models/designer-tools.model';

export const removeElement = ({ elements, elementSelected }: IToolActionParams): IToolActionResponse => {
  const elementIndex = elements.findIndex(e => e.id === elementSelected.id);

  if (elementIndex >= 0) {
    elements.splice(elementIndex, 1);
  }

  return { elementSelected: null }
}

export const bringToFront = ({ elements, elementSelected }: IToolActionParams): IToolActionResponse => {
  const elementIndex = elements.findIndex(e => e.id === elementSelected.id);

  if (elementIndex >= 0) {
    const elementFound = elements[elementIndex];

    elements.splice(elementIndex, 1);
    const elementsLength = elements.push(elementFound);
  }

  return { elementSelected };
}

export const bringForward = ({ elements, elementSelected }: IToolActionParams): IToolActionResponse => {
  const elementIndex = elements.findIndex(e => e.id === elementSelected.id);

  if (elementIndex >= 0) {
    const elementFound = elements[elementIndex];

    elements.splice(elementIndex, 1);
    elements.splice(elementIndex + 1, 0, elementFound);
  }
  
  return { elementSelected };
}

export const sendToBack = ({ elements, elementSelected }: IToolActionParams): IToolActionResponse => {
  const elementIndex = elements.findIndex(e => e.id === elementSelected.id);

  if (elementIndex >= 0) {
    const elementFound = elements[elementIndex];

    elements.splice(elementIndex, 1);
    elements.unshift(elementFound);
  }

  return { elementSelected };
}

export const sendBackward = ({ elements, elementSelected }: IToolActionParams): IToolActionResponse => {
  const elementIndex = elements.findIndex(e => e.id === elementSelected.id);

  if (elementIndex >= 0) {
    const elementFound = elements[elementIndex];

    elements.splice(elementIndex, 1);
    elements.splice(elementIndex - 1, 0, elementFound);
  }

  return { elementSelected };
}
